import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p>
        At <strong>Oza Clothing Company</strong>, your privacy is very important to
        us. This Privacy Policy explains how we collect, use, and protect your
        personal information when you visit our website, place an order, or
        interact with our services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following personal information when you shop with us:</p>
      <ul>
        <li>Full name and contact details (email, phone number, billing/shipping address).</li>
        <li>Payment information (processed securely through trusted payment gateways).</li>
        <li>Order history, clothing preferences, and sizes.</li>
        <li>Feedback, inquiries, and communication with our support team.</li>
        <li>Photos or reviews shared voluntarily for promotions or testimonials.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>Your personal data may be used to:</p>
      <ul>
        <li>Process and deliver your orders.</li>
        <li>Communicate order updates, shipping details, and customer support.</li>
        <li>Personalize your shopping experience and recommend clothing products.</li>
        <li>Send promotional emails, discounts, or updates (with your consent).</li>
        <li>Improve our website, services, and product offerings.</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <p>
        Oza Clothing Company does <strong>not</strong> sell or rent your personal
        information. We may share your details only:
      </p>
      <ul>
        <li>With trusted courier and logistics partners to fulfill your order.</li>
        <li>With secure payment gateways for processing transactions.</li>
        <li>When required by law, regulation, or legal process.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We use industry-standard security measures to protect your data against
        unauthorized access, misuse, or disclosure. Sensitive information such
        as payment details is encrypted and handled by secure providers.
      </p>

      <h2>5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access, updates, or deletion of your personal data.</li>
        <li>Opt out of marketing or promotional communications at any time.</li>
        <li>Request clarification on how your data is used or stored.</li>
      </ul>

      <h2>6. Photos, Reviews & Testimonials</h2>
      <p>
        If you share photos, reviews, or testimonials with us, we may use them
        for promotional purposes on our website or social media (with your
        consent).
      </p>

      <h2>7. Cookies</h2>
      <p>
        Our website may use cookies to enhance functionality, improve user
        experience, and analyze anonymous usage data. You can manage cookie
        preferences through your browser settings.
      </p>

      <h2>8. Policy Updates</h2>
      <p>
        Oza Clothing Company may update this Privacy Policy from time to time. Any
        changes will be posted on this page, and we encourage you to review it
        periodically.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have any privacy-related concerns, please contact us at:</p>
      <ul>
        <li>
          <strong>Phone:</strong> 9082043375
        </li>
        <li>
          <strong>Email:</strong> ozaclothingcompany@yahoo.com
        </li>
        <li>
          <strong>Address:</strong> Mumbai, MH - 400101, India
        </li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
